import { render } from "./TableOfContents.vue?vue&type=template&id=247b1925&ts=true"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__